/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text, Icon, CategoryType } from '@components/atoms'
import { grey } from '@mui/material/colors'

interface PropsType {
	title: string
	type?: 'datetime' | 'date' | 'time'
	color?: string
	category?: CategoryType
	iconStyle?: React.CSSProperties
	className?: string
}

export const DatetimeText = (props: PropsType) => {
	const type: PropsType['type'] = props.type ?? 'datetime'
	const date: string =
		props.title === ''
			? ''
			: type === 'time'
			? ''
			: type === 'date'
			? props.title
			: props.title.split(' ')[0]
	const time: string =
		props.title === ''
			? ''
			: type === 'time'
			? props.title
			: type === 'date'
			? ''
			: props.title.split(' ')[1]
	const color: string = props.color ?? grey[800]
	const category: CategoryType = props.category ?? 's2'
	const iconStyle = props.iconStyle ?? {}

	return (
		<View css={style} className={props.className}>
			{date !== '' ? (
				<View className="datetimeTitleView">
					<Icon
						name="calendar"
						className="datetimeIcon"
						style={{ ...iconStyle, color: color }}
					/>
					<Text className="datetimeTitle" category={category} style={{ color: color }}>
						{date}
					</Text>
				</View>
			) : null}
			{time !== '' ? (
				<View className="datetimeTitleView time">
					<Icon
						name="clock-outline"
						className="datetimeIcon"
						style={{ ...iconStyle, color: color }}
					/>
					<Text className="datetimeTitle" category={category} style={{ color: color }}>
						{time}
					</Text>
				</View>
			) : null}
		</View>
	)
}

const style = css({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-start',

	'.datetimeTitleView': {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		minHeight: '1rem',

		'&.time': {
			marginLeft: '0.5rem',
		},

		'.datetimeTitle': {
			margin: 0,
			lineHeight: '15px',
		},

		'.datetimeIcon': {
			fontSize: '15px',
			lineHeight: '15px',
		},
	},
})
